import { render } from "./IndexUserTeamInCompetitions.vue?vue&type=template&id=e633130c&scoped=true"
import script from "./IndexUserTeamInCompetitions.vue?vue&type=script&lang=js"
export * from "./IndexUserTeamInCompetitions.vue?vue&type=script&lang=js"

import "./IndexUserTeamInCompetitions.vue?vue&type=style&index=0&id=e633130c&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e633130c"]])

export default __exports__